import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'sortBy'})
export class SortByPipe implements PipeTransform {

  transform(ary: any, fn: Function = (a, b) => a > b ? 1 : -1): any {
    return ary.sort(fn)
  }

  /*  transform(array: any[], field: string, alt?: string): any[] {
      array.sort((a, b) => this.doSort(a, b, field, alt));
      return array;
    }

    private doSort(a: any, b: any, field: string, alt?: string) {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else if (alt && field != alt) {
        return this.doSort(a, b, alt);
      }
      return 0;
    }*/
}
